export default {
  CLIENT_LOGO: 'logo',
  PRODUCT_IMAGE: 'product',
  EXPERIENCE_IMAGE: 'experience',
  COVER_IMAGE: 'cover',
  EXP_COVER_IMAGE: 'exp_cover',
  UNIT: 'unit',
  UNIT_EXP: 'unit_exp'
}